export const labels = {
	saveButton: {
		label: "Label.MobileCreator.EventsDialog.SaveButton",
		default: "Save",
	},
	addButton: {
		label: "Label.MobileCreator.EventsDialog.AddButton",
		default: "Add Event",
	},
	editButton: {
		label: "Label.MobileCreator.EventsDialog.EditButton",
		default: "Edit Event",
	},
	cancelButton: {
		label: "Label.MobileCreator.EventsDialog.CancelButton",
		default: "Cancel",
	},
	dismissButton: {
		label: "Label.MobileCreator.EventsDialog.DismissButton",
		default: "Dismiss",
	},
	title: {
		label: "Label.MobileCreator.Events.Title",
		default: "Manage my events",
	},
	personalEventsTitle: {
		label: "Label.MobileCreator.Events.PersonalEvents.Title",
		default: "My events",
	},
	specialEventsTitle: {
		label: "Label.MobileCreator.Events.SpecialDays.Title",
		default: "Special days",
	},
	eventTitle: {
		label: "Label.MobileCreator.Events.InputField.EventTitle",
		default: "Event title",
	},
	dayNumber: {
		label: "Label.MobileCreator.Events.Dropdown.DayNumber",
		default: "DD",
	},
	monthNumber: {
		label: "Label.MobileCreator.Events.Dropdown.MonthNumber",
		default: "MM",
	},
	softLogin: {
		label: "Label.MobileCreator.Events.SoftLogin",
		default:
			"<strong>New to smartphoto?</strong></p><p>Become a smartphoto member and save your dates across products!</p>",
	},
	signIn: {
		label: "Label.MobileCreator.Events.Button.SignIn",
		default: "Sign in",
	},
	noEventsTitle: {
		label: "Label.MobileCreator.Events.Tooltip.NoEventsTitle",
		default: "No events",
	},
	noEventsText: {
		label: "Label.MobileCreator.Events.Tooltip.NoEventsText",
		default: "You don't have any events yet. Add your first event now!",
	},
	showAll: {
		label: "Label.MobileCreator.Events.Button.ShowAll",
		default: "Show all",
	},
	hideAll: {
		label: "Label.MobileCreator.Events.Button.HideAll",
		default: "Hide all",
	},
	checkedEvents: {
		label: "Label.MobileCreator.Events.Tooltip.CheckedEvents",
		default: "Custom events will be displayed in your product.",
	},
	warningTitle: {
		label: "Label.MobileCreator.Events.Warning.Errors.Title",
		default: "Errors in your events",
	},
	warningBackButton: {
		label: "Label.MobileCreator.Events.Warning.Button.Return",
		default: "Return to events",
	},
	warningEventsTitle: {
		description: {
			label: "Label.MobileCreator.Events.Warning.Errors.Description",
			default:
				"Some of your events contain error(s) that prevent you from updating your calendar.",
		},
	},
	toastDuplicateEvents: {
		description: {
			label: "Label.MobileCreator.Events.Toast.Duplicate",
			default: "Event already exists",
		},
	},
	warningAmountOfEvents: {
		description: {
			label: "Label.MobileCreator.Events.Warning.AmountOfEvents.Description",
			default: "Too many events per day.",
		},
	},
	warningTextTooLong: {
		description: {
			label: "Label.MobileCreator.Events.Warning.TotalText.Description",
			default: "Text too long.",
		},
	},
	warningUnusedUserDates: {
		description: {
			label: "Label.MobileCreator.Events.Warning.AvailableCalendarDay.Description",
			default:
				"Following calendar days do not exist in the current calendar period and will therefore not be shown in the calendar.",
		},
	},
	warningUnsavedChanges: {
		dontSaveButton: {
			label: "Label.MobileCreator.Events.Warning.Unsaved.DontSaveButton",
			default: "Don't Save",
		},
		saveButton: {
			label: "Label.MobileCreator.Events.Warning.Unsaved.SaveButton",
			default: "Save",
		},
		description: {
			label: "Label.MobileCreator.Events.Warning.Unsaved.Description",
			default: "You have unsaved changes. By leaving you will lose your progress.",
		},
		title: {
			label: "Label.MobileCreator.Events.Warning.Unsaved.Title",
			default: "Unsaved events",
		},
	},
	specialDays: {
		Holiday: {
			label: "Label.MobileCreator.Events.Holiday.Show",
			default: "Add holidays",
		},
		FlagDay: {
			label: "Label.MobileCreator.Events.FlagDay.Show",
			default: "Add flag days",
		},
		NameDay: {
			label: "Label.MobileCreator.Events.NameDay.Show",
			default: "Add name days",
		},
	},
} as const;
